module.exports = __webpack_public_path__ + "static/img/logo_affixe.4a907d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_affixe.svg
// module id = +Lgj
// module chunks = 3